import { Grid } from "@mui/material";
import React from "react";
import PointsTransactionsTable from "./table";

const PointsTransactions = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PointsTransactionsTable />
      </Grid>
    </Grid>
  );
};

export default PointsTransactions;
